import { create } from 'zustand'
import type {
  LaunchTransitionOrigin,
  LaunchTransitionPresentation,
  LaunchTransitionStore,
} from '@/stores/launchTransition.types'

// Resolvers for in-flight beginCover() promises; module-level because the
// store state must stay serializable.
let coveredResolvers: Array<() => void> = []

function resolveCovered() {
  const resolvers = coveredResolvers
  coveredResolvers = []

  for (const resolve of resolvers) resolve()
}

// App-level launch outro (onboarding finish → builder). The overlay component
// renders from this store above the router, so the cover survives the route
// swap and any intermediate redirect happens invisibly underneath it.
export const useLaunchTransition = create<LaunchTransitionStore>()(
  (set, get) => ({
    phase: 'idle',
    origin: null,
    presentation: 'vwam',

    beginCover(
      origin: LaunchTransitionOrigin,
      presentation: LaunchTransitionPresentation = 'vwam'
    ) {
      if (get().phase === 'covering') {
        return new Promise<void>((resolve) => {
          coveredResolvers.push(resolve)
        })
      }

      if (get().phase !== 'idle') return Promise.resolve()

      set({ phase: 'covering', origin, presentation })

      return new Promise<void>((resolve) => {
        coveredResolvers.push(resolve)
      })
    },

    markCovered() {
      if (get().phase !== 'covering') return

      set({ phase: 'covered' })
      resolveCovered()
    },

    reveal() {
      if (get().phase !== 'covered') return

      set({ phase: 'revealing' })
    },

    reset() {
      resolveCovered()
      set({ phase: 'idle', origin: null, presentation: 'vwam' })
    },
  })
)
